export default __webpack_public_path__ + "static/media/Rectangle 3747.8922d7cf.png";